/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsPortfolioSortCriteria {
    getFixupPrototypeFunction() { return AppSecopsPortfolioSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsPortfolioSortCriteria>): AppSecopsPortfolioSortCriteria {
        let obj = Object.assign(new AppSecopsPortfolioSortCriteria(), model);
        AppSecopsPortfolioSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsPortfolioSortCriteria>): AppSecopsPortfolioSortCriteria {
        if (!model) return null;
        return AppSecopsPortfolioSortCriteria.newInstance(<AppSecopsPortfolioSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsPortfolioSortCriteria) {
        if (!obj) return;

        models.AppSecopsPortfolioSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsPortfolioSortCriteria): boolean {
        Object.setPrototypeOf(obj, AppSecopsPortfolioSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AppSecopsPortfolioSortColumn;

    ascending: boolean;

}
